import styled from 'styled-components'
import { DisplayFlex } from '../StyledElems'

const Values = styled(DisplayFlex)`
  margin-bottom: 20px;
  & > div {
    margin-right: 35px;
    width: 220px;
  }
`
export default Values
